import { CustomDialog } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(CustomDialog)`
  .MuiPaper-root {
    background: ${(p) => p.theme.palette.grey[200]};
    padding: 0 !important;
  }
  .MuiDialogActions-root {
    display: none;
  }
`;
